import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const GenericTextInputCss = css`
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    border-radius: 0.75rem;
    border: 2px solid var(--Neutral-300, #d4d4d8);
    background: var(--Neutral-0, #fff);

    &:focus {
        outline: none;
    }

    color: var(--Neutral-950, #09090b);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;

    &[aria-invalid='true'] {
        border: 2px solid var(--Neutral-300, #e11d48);

        &::placeholder {
            color: #e11d48;
            opacity: 1;
        }
    }
`;

export const GenericTextInput = styled.input`
    ${GenericTextInputCss}
`;

export const GenericPasswordInputWrapper = styled.div`
    display: flex;
    align-items: center;
    ${GenericTextInputCss}
    padding: 0;
    padding-right: 1rem;

    input {
        ${GenericTextInputCss}
        border: none;
        flex: 1;
    }

    svg {
        font-size: 1.5rem;
        color: #999999;
    }

    &[aria-invalid='true'] {
        input::placeholder {
            color: #e11d48;
            opacity: 1;
        }
    }
`;

export const PhoneInputWrapper = styled(GenericPasswordInputWrapper)`
    padding-right: 0;
    overflow: hidden;
    input:last-child {
        width: 100%;
        padding-left: .5rem;
    }

    .phone-dropdown {
        min-width: 8rem;
    }

    .number-only {
        position: relative;
        flex-grow: 1;
        border: none;
        min-width: 0;
        height: 100%;
        border-radius: 0;
        padding: 0.75rem;
        padding-right: 0;
        color: #18181b;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5rem;
        gap: 0.1rem;
        flex: 0;
        min-width: 3.5rem;
        padding-right: .25rem;
    }

    .divider {
        width: 2px;
        height: 2rem;
        background-color: #d4d4d8;
    }
`;

export const ToggleInputWrapper = styled(motion.div)`
    display: flex;
    align-items: center;
    width: 2.75rem;
    height: 1.25rem;

    flex-shrink: 0;
    border-radius: 1.5rem;
    background: #a1a1aa80;
    padding: 0 0.2rem;
    cursor: pointer;
    outline: 2px solid #a1a1aa80;
    transition: background 0.1s outline 0.1s;

    span {
        display: flex;
        width: 1rem;
        height: 1rem;
        flex-shrink: 0;
        background-color: var(--Neutral-0, #fff);
        border-radius: 50%;
    }

    &[aria-checked='true'] {
        background: var(--Supernova-500, #ffcf00);
        outline: 2px solid #ffcf00;
    }
`;


export const StyledRadioInput = styled.div`
    display: flex;
    align-items: center;
    gap: .5rem;

    button.pseudo-checkbox {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 0.75rem;
        background-color: rgba(228, 228, 231, 0.50);
        border: 2px solid rgba(212, 212, 216, 0.50);
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;        

        position: relative;
        transition: border 0.1s;

        &::before {
            content: '';
            position: absolute;
            width: 70%;
            height: 70%;
            background-color: #EAB308;
            border-radius: 50%;
            opacity: 0;
            transition: opacity 0.1s;
            /* left: 0; */
            /* top: 0; */
            /* transform: translate(25%, 25%); */
        }

        &.active {
            border-color: #EAB308;

            &::before {
                opacity: 1;
            }
        }

        &[disabled] {
            cursor: not-allowed;
        }
    }

    label[aria-disabled='true'] {
        color: #c4c4c4;
        cursor: not-allowed;
    }
`;